// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICopayDto } from './ICopayDto';
import {
    ICopayDtoFromJSON,
    ICopayDtoFromJSONTyped,
    ICopayDtoToJSON,
    ICopayDtoToJSONTyped,
} from './ICopayDto';

/**
 * 
 * @export
 * @interface ICopayGroupDto
 */
export interface ICopayGroupDto {
    /**
     * 
     * @type {number}
     * @memberof ICopayGroupDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICopayGroupDto
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof ICopayGroupDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICopayGroupDto
     */
    organization_path?: string;
    /**
     * 
     * @type {string}
     * @memberof ICopayGroupDto
     */
    organization_type?: ICopayGroupDtoOrganizationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ICopayGroupDto
     */
    valid_from?: string;
    /**
     * 
     * @type {string}
     * @memberof ICopayGroupDto
     */
    valid_to?: string;
    /**
     * 
     * @type {Array<ICopayDto>}
     * @memberof ICopayGroupDto
     */
    copays?: Array<ICopayDto>;
}

/**
* @export
* @enum {string}
*/
export enum ICopayGroupDtoOrganizationTypeEnum {
    SYSTEM = 'SYSTEM',
    PARTNER = 'PARTNER',
    DISTRIBUTOR = 'DISTRIBUTOR',
    COMPANY = 'COMPANY',
    SUBSIDIARY = 'SUBSIDIARY',
    SUBGROUP = 'SUBGROUP'
}


/**
 * Check if a given object implements the ICopayGroupDto interface.
 */
export function instanceOfICopayGroupDto(value: object): value is ICopayGroupDto {
    return true;
}

export function ICopayGroupDtoFromJSON(json: any): ICopayGroupDto {
    return ICopayGroupDtoFromJSONTyped(json, false);
}

export function ICopayGroupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICopayGroupDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'organization_type': json['organization_type'] == null ? undefined : json['organization_type'],
        'valid_from': json['valid_from'] == null ? undefined : json['valid_from'],
        'valid_to': json['valid_to'] == null ? undefined : json['valid_to'],
        'copays': json['copays'] == null ? undefined : ((json['copays'] as Array<any>).map(ICopayDtoFromJSON)),
    };
}

export function ICopayGroupDtoToJSON(json: any): ICopayGroupDto {
    return ICopayGroupDtoToJSONTyped(json, false);
}

export function ICopayGroupDtoToJSONTyped(value?: ICopayGroupDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'organization_type': value['organization_type'],
        'valid_from': value['valid_from'],
        'valid_to': value['valid_to'],
        'copays': value['copays'] == null ? undefined : ((value['copays'] as Array<any>).map(ICopayDtoToJSON)),
    };
}

